import { __assign, __extends } from "tslib";
/**
/**
 * Created by Katarzyna.Zabelska on 2022-02-21.
 * Used details/financial details accordions on all BC where content is injected after recalculation
 *
 */
import BSSAccordionComponent from './bss-accordion-component.js';
import BSSTableComponent from '../../bss-table-component/js/bss-table-component.js';
import logger from '@main/externals/bss-package-logger/js/logger';
var BSSDynamicContentAccordionComponent = /** @class */ (function (_super) {
    __extends(BSSDynamicContentAccordionComponent, _super);
    /**
     *
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [eventManager=null] instance of _EventManager
     * @param {Formatter} [formatter=null] instance of Formatter
     * @param {Resolution} [resolution=null] Resolution class for width breakpoint handling
     * @param {Toolbox} [toolbox=null] instance of Toolbox object
     */
    function BSSDynamicContentAccordionComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) || this;
        /**
         * @desc inject components into BC accordion
         * @param {String} name - publisher name
         * @param {Object} eventData - event data
         * @param {Event} accordionClickEvent accordion click event event object
         * @private
         */
        _this._injectComponentsIntoBcAccordion = function (accordionClickEvent, name, eventData) {
            var _a;
            if (name === void 0) { name = null; }
            if (eventData === void 0) { eventData = null; }
            logger.info('DynamicContentAccordionComponent ' +
                _this._config.componentId +
                ' => function : _injectComponentsIntoBcAccordion | Params: ', name, eventData, accordionClickEvent);
            // when there is recalculation, save grade, from for clicked accordion - needed for tagging
            var resultData = ((_a = _this._toolbox) === null || _a === void 0 ? void 0 : _a.resultDataFlat[_this._config.productId[0]]) || null;
            _this._modelName = resultData.modelName;
            _this._gradeName = resultData.gradeName;
            _this._priceDisplay = resultData.priceDisplay;
            var contentConfig = _this._config.contentConfig;
            var contentContainerId = "#".concat(_this._config.componentId, "_content");
            var $contentContainerEl = _this._toolbox.$(contentContainerId);
            // check if a container of an accorion content and uidesc configuration exists, then inject content components inside an accordion
            if ($contentContainerEl.length && (contentConfig === null || contentConfig === void 0 ? void 0 : contentConfig.length)) {
                for (var _i = 0, contentConfig_1 = contentConfig; _i < contentConfig_1.length; _i++) {
                    var contentConfigComponent = contentConfig_1[_i];
                    var detailsContentComponentIdPrefix = contentConfigComponent.componentIdPrefix;
                    contentConfigComponent.componentId = "".concat(detailsContentComponentIdPrefix, "-").concat(_this._config.carId);
                    contentConfigComponent.containerId =
                        _this._config.componentId + '_content';
                    // inject any other component if needed
                    if (contentConfigComponent.componentType === 'TableComponent') {
                        _this._injectTableComponentIntoBcAccordion(contentContainerId, contentConfigComponent, eventData);
                    }
                }
                // if component is injected
                if ($contentContainerEl.html().trim()) {
                    // show accordion content
                    _this._showAccordionContent(accordionClickEvent);
                    // set flag for accordion that data has been loaded
                    _this._$componentEl.addClass('is-loaded');
                }
            }
        };
        /**
         * @desc disable accordion: add disable class, unbind click
         * @private
         */
        _this._disableAccordion = function () {
            logger.info('BSSDynamicContentAccordionComponent ' +
                _this._config.componentId +
                ' => function : _disableAccordion');
            _this._$componentEl.addClass('bss-accordion--disabled');
            _this._$accordionTitle.off('click.' + _this._config.componentId);
        };
        logger.info('DynamicContentAccordionComponent: => constructor : componentId: ' +
            _this._config.componentId +
            ' | Params: ', _entityTemplate, containerSelector, config, eventManager, formatter, resolution, logger, toolbox);
        return _this;
    }
    /**
     * @desc inject table component into BC accordion
     * @param {String} contentContainerId - content container id, where table is injected
     * @param {Object} contentConfigComponent - uiDesc for accordion table component
     * @param {Object} eventData - eventData object from bss-accordion-show-content event
     * @private
     */
    BSSDynamicContentAccordionComponent.prototype._injectTableComponentIntoBcAccordion = function (contentContainerId, contentConfigComponent, eventData) {
        logger.info('BSSDynamicContentAccordionComponent ' +
            this._config.componentId +
            ' function : _updateT_injectTableComponentIntoBcAccordionbleForEmptyValues| Params: ', contentContainerId, contentConfigComponent, eventData);
        var resultData = eventData.resultData;
        var globalTexts = eventData.globalTexts;
        var resultDataCalculations = resultData['calculations'];
        var contentConfigData = contentConfigComponent.data;
        var isData = false;
        // add data from resultData
        // if ui-desc data refer to calculations
        if (contentConfigData === 'calculations' &&
            (resultDataCalculations === null || resultDataCalculations === void 0 ? void 0 : resultDataCalculations.length)) {
            isData = true;
            contentConfigComponent.data = resultDataCalculations.map(function (el) { return ({
                col1: el['name'],
                col2: el['value'],
            }); });
            // if ui-desc data refer to any other data: table component configurations
        }
        else if (Array.isArray(contentConfigData)) {
            // loop every table configuration
            contentConfigData.forEach(function (el, index) {
                isData = true;
                var paramCol1Value = null;
                if (contentConfigComponent.componentIdPrefix ===
                    'bcFinancialDetailsLegalTextsTable') {
                    paramCol1Value = resultData[el.col1];
                }
                else {
                    var col1Name = el.col1.split('.');
                    var paramCol1Name = col1Name && col1Name.length && col1Name[1];
                    paramCol1Value = globalTexts[paramCol1Name] || null;
                }
                contentConfigData[index].col1 = paramCol1Value || '';
                var paramCol2Name = el.col2;
                if (paramCol2Name) {
                    var paramCol2Value = resultData[paramCol2Name] || null;
                    contentConfigData[index].col2 = paramCol2Value || '';
                }
            });
        }
        if (isData) {
            new BSSTableComponent(this._entityTemplate, contentContainerId, contentConfigComponent, this._eventManager, this._formatter, this._resolution, this._toolbox);
        }
        // if component is injected
        if (this._toolbox.$(contentContainerId).html().trim()) {
            // hide table rows for empty values
            this._updateTableForEmptyValues(contentConfigComponent);
            // reset values for connector offer recalculation
            this._eventManager.publish("bss-list-box-accordion-content-shown-".concat(this._config.elementType), 'bss-accordion-component');
        }
    };
    /**
     * @desc hide table rows which have empty values
     * @param {Object} contentConfigComponent - uiDesc configuration for table
     * @private
     */
    BSSDynamicContentAccordionComponent.prototype._updateTableForEmptyValues = function (contentConfigComponent) {
        logger.info('BSSDynamicContentAccordionComponent ' +
            this._config.componentId +
            ' function : _updateTableForEmptyValues| Params: ', contentConfigComponent);
        var componentId = contentConfigComponent.componentId;
        var tableRows = this._toolbox.$("#".concat(componentId)).find('.bss-table_tr');
        var elClass = contentConfigComponent.componentIdPrefix ===
            'bcFinancialDetailsLegalTextsTable'
            ? 'bss-table_td--odd'
            : 'bss-table_td--even';
        var _self = this;
        tableRows.each(function () {
            var $self = _self._toolbox.$(this);
            var value = $self.find(".".concat(elClass)).html();
            var valueShow = value && value !== '' && value !== '0';
            $self.toggle(valueShow);
        });
    };
    /**
     * @desc shows accordion content after click on arrow
     * @param {Event} accordionClickEvent accordion click event event object
     * @private
     * @override
     */
    BSSDynamicContentAccordionComponent.prototype._showAccordionContent = function (accordionClickEvent) {
        var _a;
        logger.info('BSSDynamicContentAccordionComponent ' +
            this._config.componentId +
            ' function : _showAccordionContent| Params: ', accordionClickEvent);
        this._$accordionContent.slideDown(this._$animDuration);
        this._$accordionArrow.addClass(this._arrowClass);
        this._componentScope.addClass(this._activeClass);
        var accordionOpenTagEvent = (((_a = this._config) === null || _a === void 0 ? void 0 : _a.tagEvent) || {}).accordionOpenTagEvent;
        if (accordionOpenTagEvent) {
            this._toolbox.resultDataFlat[this._config.productId[0]].isVariantList =
                (accordionOpenTagEvent === null || accordionOpenTagEvent === void 0 ? void 0 : accordionOpenTagEvent.isVariantList) || false;
            this._onTaggingEvent(accordionOpenTagEvent === null || accordionOpenTagEvent === void 0 ? void 0 : accordionOpenTagEvent.throwEvent, accordionOpenTagEvent === null || accordionOpenTagEvent === void 0 ? void 0 : accordionOpenTagEvent.throwAfterCalculation, accordionClickEvent);
        }
    };
    /**
     * @desc add information about carId, entity, integrationMode
     * @param {String} throwEvent
     * @param {Boolean} [recalculation=false]
     * @param {jQuery|HTMLElement} target
     * @emits {throwEvent}
     * @private
     * @override
     */
    BSSDynamicContentAccordionComponent.prototype._throwTaggingEvent = function (throwEvent, recalculation, target) {
        var _a, _b, _c;
        if (recalculation === void 0) { recalculation = false; }
        logger.info('BSSDynamicContentAccordionComponent ' +
            this._config.componentId +
            ' function : _throwTaggingEvent| Params: ', throwEvent, recalculation, target);
        var productId = this._config.productId[0];
        var isVariantList = ((_a = this._config) === null || _a === void 0 ? void 0 : _a.isVariantList) || false;
        var resultDataFlat = this._toolbox.resultDataFlat[productId];
        (_c = (_b = this._toolbox.dxpTagging) === null || _b === void 0 ? void 0 : _b[this._toolbox.currentEntity.entityId]) === null || _c === void 0 ? void 0 : _c.publish(throwEvent, __assign(__assign({}, resultDataFlat), { isVariantList: isVariantList, integrationMode: (resultDataFlat === null || resultDataFlat === void 0 ? void 0 : resultDataFlat.integrationMode) || null }));
    };
    /**
     * @desc does action on accordion's title click
     * @param {Event} accordionClickEvent accordion click event event object
     * @private
     * @override
     */
    BSSDynamicContentAccordionComponent.prototype._onClickAccordion = function (accordionClickEvent) {
        logger.info('BSSDynamicContentAccordionComponent ' +
            this._config.componentId +
            ' function : _onClickAccordion| Params: ', accordionClickEvent);
        this._setDynamicAccordionsLogic(accordionClickEvent);
    };
    /**
     * @desc for dynamic accordion click, set accordion listeners: publish event for listBox to prepare data for request
     * and subscribe for final content show. If already loaded, just show content
     * @param {Event} accordionClickEvent accordion click event event object
     * @emits {bss-list-box-prepareData-for-request-$ACCORDION_NAME-$CAR_ID}
     * @listens {bss-accordion-show-content}
     * @listens {bss-accordion-disable}
     * @private
     */
    BSSDynamicContentAccordionComponent.prototype._setDynamicAccordionsLogic = function (accordionClickEvent) {
        logger.info('BSSDynamicContentAccordionComponent ' +
            this._config.componentId +
            ' => function : _setDynamicAccordionsLogic| Params: ', accordionClickEvent);
        // if Budget Calculator
        if (this._config.elementType == 'bcDetails' ||
            this._config.elementType == 'bcFinancialDetails') {
            // if an accordion content has been loaded - just show or hide content
            // there is no need to send another request
            if (this._$componentEl.hasClass('is-loaded')) {
                if (this._isAccordionContentVisible()) {
                    this._hideAccordionContent();
                }
                else {
                    // when there is no recalculation, update for a while 'grade', 'from' for clicked accordion - needed for tagging
                    // after tagging get back to the last recalculation 'grade', 'from' in resultDataFlat
                    var resultDataFlat = this._toolbox.resultDataFlat[this._config.productId[0]];
                    var gradeName = resultDataFlat === null || resultDataFlat === void 0 ? void 0 : resultDataFlat.gradeName;
                    var modelName = resultDataFlat === null || resultDataFlat === void 0 ? void 0 : resultDataFlat.modelName;
                    var priceDisplay = resultDataFlat === null || resultDataFlat === void 0 ? void 0 : resultDataFlat.priceDisplay;
                    this._updateResultData(resultDataFlat);
                    this._showAccordionContent(accordionClickEvent);
                    this._updateResultData(resultDataFlat, gradeName, modelName, priceDisplay);
                }
                return;
            }
            // if an accordion content has not been loaded - will be loaded for the first time
            // publish event for list-box for preparing data for request
            // listen to final show content event
            var $carBox = this._$componentEl.closest('.bss-list-box_item');
            var carId = $carBox && $carBox.attr('data-id');
            this._eventManager.unsubscribeByOwner('BCAccordionClick');
            this._eventManager.subscribe('bss-accordion-show-content', this._injectComponentsIntoBcAccordion.bind(this, accordionClickEvent), 'BCAccordionClick');
            this._eventManager.publish('bss-list-box-prepareData-for-request-' +
                this._config.elementType +
                '-' +
                carId, 'bss-accordion', { carId: carId });
            // subscribe for disable accordion event
            this._eventManager.unsubscribeByOwner('BCAccordionDisable');
            this._eventManager.subscribe('bss-accordion-disable', this._disableAccordion, 'BCAccordionDisable');
        }
    };
    /**
     * @desc update resultData  - needed for tagging
     * @param {resultDataFlat} object with data to update
     * @param {String} gradeName
     * @param {String} modelName
     * @param {String} priceDisplay
     */
    BSSDynamicContentAccordionComponent.prototype._updateResultData = function (resultDataFlat, gradeName, modelName, priceDisplay) {
        if (gradeName === void 0) { gradeName = this._modelName; }
        if (modelName === void 0) { modelName = this._gradeName; }
        if (priceDisplay === void 0) { priceDisplay = this._priceDisplay; }
        resultDataFlat.modelName = modelName;
        resultDataFlat.gradeName = gradeName;
        resultDataFlat.priceDisplay = priceDisplay;
        return resultDataFlat;
    };
    return BSSDynamicContentAccordionComponent;
}(BSSAccordionComponent));
export default BSSDynamicContentAccordionComponent;
